import {NavLink} from "react-router-dom";
import Wallet, {selectStakingAPY} from "../store/models/wallet";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

export const CTAPill = ({ text, onClick, href, style }) => {
    return (
        <NavLink className={'CTAPill'}
                 style={style}
                 to={href}
                 onClick={onClick}
        >
            {text}
        </NavLink>
    )
};

export const StakeAPYCTA = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const stakingAPY = useSelector(selectStakingAPY);

    useEffect(() => {
        dispatch(Wallet.actions.fetchStakingAPY());
    }, []);

    return (
        <CTAPill text={
            <>
                <span>{t('cta.stake_apy.title')}</span>
                <span className={'color--brand'}>{`${stakingAPY ? stakingAPY : '~' }% APY`}</span>
                <span> ></span>
            </>}
                 href={'/stake'}
        />
    )
}

export const StakeAPYInfo = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const stakingAPY = useSelector(selectStakingAPY);

    useEffect(() => {
        dispatch(Wallet.actions.fetchStakingAPY());
    }, []);

    return (
        <CTAPill text={
            <>
                <span>{t('cta.stake_apy_info.title')}</span>
                <span className={'color--brand'}>{`${stakingAPY ? stakingAPY : '~' }% APY`}</span>
            </>}
        />
    )
}

export const StakeAPYEarnInfo = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const stakingAPY = useSelector(selectStakingAPY);

    useEffect(() => {
        dispatch(Wallet.actions.fetchStakingAPY());
    }, []);

    return (
        <CTAPill text={
            <>
                <span>Earn up to </span>
                <span className={'color--red'}>{`${stakingAPY ? stakingAPY : '~' }% APY`}</span>
            </>}
        />
    )
}

export default CTAPill;